import React from 'react';
import { motion } from 'framer-motion';
export function DeviceMockups() {
  return <div className="relative w-full flex items-center justify-center" data-id="element-179">
      {/* Background blurred circles */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-gold/20 rounded-full blur-3xl animate-float pointer-events-none" style={{
      animationDelay: '0s'
    }} data-id="element-180" />
      <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-combo-green/10 rounded-full blur-3xl animate-float pointer-events-none" style={{
      animationDelay: '2s'
    }} data-id="element-181" />
      <motion.img src="https://cdn.magicpatterns.com/uploads/koAuYcVPwKfUPtnuUNfT2G/Mockup_recetas_power_fit.png" alt="Mockup de los kits digitales Recetas PowerFit: tablet, celular y ebook con plan semanal y lista de compras" initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="relative z-10 w-full max-w-[640px] h-auto drop-shadow-[0_30px_60px_rgba(0,0,0,0.15)]" data-id="element-182" />
      {/* Floating bestseller-style badge accent (gold ring on top-right) */}
      <motion.div initial={{
      opacity: 0,
      scale: 0,
      rotate: -45
    }} animate={{
      opacity: 1,
      scale: 1,
      rotate: 0
    }} transition={{
      duration: 0.6,
      delay: 0.6,
      type: 'spring'
    }} className="absolute top-4 right-4 lg:top-8 lg:right-8 z-20 bg-gold text-white px-4 py-2 rounded-full font-bold text-xs shadow-lg border-2 border-white animate-float" style={{
      animationDelay: '1s'
    }} data-id="element-183">
        ⭐ #1 EN VENTAS
      </motion.div>
    </div>;
}